'use strict';

angular.module('mean.projects').factory('lotScheduleService', ['$filter', 'ProjectTasks', '$q', 'taskService', 'moment', 'Holidays', 'tradeCodeService', 'toaster', 'userService',
    function($filter, ProjectTasks, $q, taskService, moment, Holidays, tradeCodeService, toaster, userService) {

        var holidays = [];
        var dateFormat = 'yyyy-MM-dd';

        var setHolidaysArray = function(username) {
            userService.getMainAccount(username).then(function(account) {
                Holidays.query({'main_account_id': account._id}, function(holiday_db) {
                    if(holiday_db.length === 1) {
                        _.each(holiday_db[0].entries, function(entry) {
                            holidays.push($filter('date')(entry.date, dateFormat));
                        });
                    }
                });
            });
        };

        // Disable weekend selection
        var disabled = function(date, mode) {
            if(mode === 'day') {
                if(holidays.indexOf($filter('date')(date, dateFormat)) !== -1) {
                    return 1;
                } 
            }
            return ( mode === 'day' && ( date.getDay() === 0 || date.getDay() === 6 ) );
        };

        //$scope.selectedItem === project
        //$scope.user === user
        //$scope.tm_users === tm_users
        //$scope.bid_tasks === bid_tasks
        var schedule = function(lot, project, bid_tasks, user, tm_users) {
            console.log('Need to schedule lot ' + lot.number + 
                ' with start date: ' + moment(lot.start_date).format('YYYY-MM-DD'));
            
            var ordered_tasks = $filter('orderBy')(project.plan[0].task_list, 'days_offset', false);

            var current_day = moment(lot.start_date);
            var day_count = 0;
            var off_days = 0;
            var day_incrementor = 0;
            var task_incrementor = 0;
            var starting_job_code = 1;
            var not_done = true;

            var owner_main_username = tradeCodeService.getCode(user.trade[0]) +
                                user.contractor_code + '0000';

            current_day.hour(7);
            current_day.minute(0);
            current_day.second(0);

            var deferred = $q.defer();
            var returned_items = [];

            //this is really ugly but it's the best i got.  because the schedule section
            //only gives me days_offset from the start date, I have to go through and 
            //figure out which days are holidays or weekends.  And because a project
            //does not track all tasks but only tasks assign via the trade, I can't just
            //iterate over the ordered_tasks.  
            for(var i=0; i<550 && not_done; i++) {
                //is today a holiday or weekend
                if(disabled(new Date(current_day), 'day')) off_days += 1;

                day_count = day_incrementor - off_days;

                ordered_tasks[task_incrementor].task_code =
                    ordered_tasks[task_incrementor].trade + ordered_tasks[task_incrementor].task;

                if(day_count === ordered_tasks[task_incrementor].days_offset) {
                    //get the actual trade manager from the project for the particular trade
                    var manager;
                    if(tradeCodeService.getName(ordered_tasks[task_incrementor].trade)) {
                        manager = $filter('filter')(project.trades, {
                            'name': tradeCodeService.getName(ordered_tasks[task_incrementor].trade)})[0];
                    }

                    var tm = {};
                    var fm = {};

                    if(manager) {
                        var holder = {};
                        var found = false;
                        //this task could be designated for another management combination
                        //so check here and set.
                        _.each(manager.management_combinations, function(combo) {
                            var gotCombo = $filter('filter')(combo.tasks, { 
                                'code': ordered_tasks[task_incrementor].task_code }, true);

                            if(gotCombo.length === 1) {
                                found = true;
                                holder = combo.manager.username;
                                fm = combo.foreman;
                            }
                        });

                        //did not find an alternate management combo, set to default or main username
                        if(!found)
                          holder = (manager.manager.username) ? manager.manager.username : manager.main_username;

                        //get the system specific trade manager so we can pass the id
                        var inlist = $filter('filter')(tm_users, {'username': holder }, true);
                        if(inlist.length !== 1) {
                            toaster.pop('error', 'Manager Error', 'Problem setting the trade manager.  Setting the admin account.');
                            tm = user;
                        } else {
                            tm = inlist[0];
                        }

                        if(!found)
                          fm = manager.foreman;
                    } else {
                        //if there is no manager then that means
                        //it is not a system task so set the manager
                        //to the MTC user id
                        tm = user;
                    }

                    var main_username = tradeCodeService.getCode(tm.trade[0]) +
                                tm.contractor_code + '0000';

                    var bid_t = $filter('filter')(bid_tasks,{
                        'task_code': ordered_tasks[task_incrementor].task_code, 'plan_code': lot.plan}, true)

                    if(bid_t.length === 0) {
                        bid_t.push({
                            '_id': 0
                        });
                    }
                    
                    //create the end date and set the timezone
                    var end_date = moment(current_day);
                    end_date.add(ordered_tasks[task_incrementor].days - 1, 'days');
                    end_date.hour(15);
                    end_date.minute(30);
                    var bid_hours = 0;

                    if(bid_t[0]._id !== 0) {
                        console.log('Setting labor hours ' + bid_t[0].totals.hours_allowed +
                            ' for task code ' + bid_t[0].task_code);
                        bid_hours = bid_t[0].totals.hours_allowed
                    }

                    var formatString = 'yyyy-MM-ddTHH:mm' + project.contact.timezone;
                    //console.log('Using formatString value: ' + formatString);
                    var new_task = new ProjectTasks({
                        task_name: ordered_tasks[task_incrementor].name,
                        trade: tradeCodeService.getName(ordered_tasks[task_incrementor].trade),
                        trade_manager_id: tm._id,
                        assigned_main_trade_username: main_username,
                        owner_main_username: owner_main_username,
                        project_id: project._id,
                        //project_bid_id: bid_t[0]._id,
                        foreman: fm,
                        task_code: ordered_tasks[task_incrementor].task_code,
                        plan_code: lot.plan,
                        start_date: $filter('date')(new Date(current_day), formatString),
                        end_date: $filter('date')(new Date(end_date), formatString),
                        lot: lot.number,
                        days: ordered_tasks[task_incrementor].days,
                        days_offset: ordered_tasks[task_incrementor].days_offset,
                        timezone: project.contact.timezone,
                        company_code: project.company_code,
                        trade_code: project.trade_code,
                        division: {
                            name: project.name,
                            address_one: project.contact.address_one,
                            address_two: project.contact.address_two,
                            city: project.contact.city,
                            state: project.contact.state,
                            zip: project.contact.zip
                        },
                        job_code: project.job_code,
                        phase: lot.phase,
                        status: 'on_track',
                        hot_sheet: false,
                        bid_hours: bid_hours,
                        actual_man_hours: 0,
                        actual_labor_costs: 0,
                        actual_material_costs: 0,
                        actual_equipment_costs: 0,
                        notes: {
                            date: new Date(),
                            comment: 'Task created',
                            username: user.username
                        }
                    });

                    if(bid_t[0]._id)
                      new_task.project_bid_id = bid_t[0]._id;

                    //new_task.$save();
                    returned_items.push(new_task);

                    starting_job_code  += 1;
                    task_incrementor += 1;
                } else {
                    if(ordered_tasks[task_incrementor].trade === '13')
                        console.log('Painting task is not getting scheduled');
                }

                //if there are no more tasks to schedule, then just move along.
                if(!ordered_tasks[task_incrementor]) {
                    console.log('We\'re done with task scheduling');
                    not_done = false;
                    break;
                }

                //need to check the next task in the list to make sure it
                //is not scheduled on the same day.
                if(day_count !== ordered_tasks[task_incrementor].days_offset) {
                    day_incrementor += 1;
                    current_day.add(1, 'day');
                }
            }

            $q.all(returned_items).then(function(results) {
                deferred.resolve(results);
            });

            return deferred.promise;
        };

        return {
            setHolidaysArray: setHolidaysArray,
            disabled: disabled,
            schedule: schedule
        };
    }
]);


// WEBPACK FOOTER //
// ./packages/custom/projects/public/services/lot-schedule-service.js